import { createRouter, createWebHistory } from 'vue-router';
import { useStore } from 'vuex'
import { isAuthRout } from '@/router/middleware/authMw'
import { permissionRout } from '@/router/middleware/permissionRout'

import HomePage from '@/pages/HomePage.vue';
import NotFound from '@/pages/NotFound.vue';
import Login from '@/pages/Login.vue';
import SecurityOptions from '@/pages/SecurityOptions.vue';
import TempaleTmsCandidate from '@/pages/trip/TempaleTmsCandidate.vue';

import MyRoutes from '@/pages/ati/MyRoutes.vue' ;
import AtiList from '@/pages/ati/RouteList.vue' ;
import RouteForAti from '@/pages/ati/RouteForAti.vue' ;
import RouteEnrichment from '@/pages/ati/RouteEnrichment.vue' ;
import PriceCheck from '@/pages/ati/PriceCheck.vue' ;
import RouteCost from '@/pages/ati/RouteCost.vue' ;
import UserSetting from '@/pages/users/UserSettings.vue';
import UsersList from '@/pages/users/user-routing/UsersListSection.vue';
import CompanyList from '@/pages/securityCheck/CompanyList.vue'
import Executors from '@/pages/securityCheck/Executors.vue'
import CargoList from '@/pages/trip/CargoList.vue'
import TripsBoardPage from '@/modules/trips/TripsBoardPage.vue'
import CustomerList from '@/pages/customer/CustomerList.vue'
import CarList from '@/pages/securityCheck/CarList.vue';
import DriverList from '@/pages/securityCheck/DriverList.vue'

import DriverDetail from '@/pages/securityCheck/DriverDetail.vue'
import CarDetail from '@/pages/securityCheck/CarDetail.vue'
import TrailerList from '@/pages/securityCheck/TrailerList.vue';
import TrailerDetail from '@/pages/securityCheck/TrailerDetail.vue';
import ManagerList from '@/pages/securityCheck/ManagerList.vue';
import ManagerDetail from '@/pages/securityCheck/ManagerDetail.vue';
import CompanyDetail from '@/pages/securityCheck/CompanyDetail.vue'
import TopClients from '@/pages/securityCheck/TopClients.vue'
import ExecutorsDetail from '@/pages/securityCheck/ExecutorDetailHub.vue'
import ExecutorDetailStep from '@/pages/securityCheck/ExecutorDetailStep.vue'

import CarCreatePage from '@/pages/securityCheck/CarCreatePage.vue'
import DriverCreatePage from '@/pages/securityCheck/DriverCreatePage.vue'
import ManagerCreatePage from '@/pages/securityCheck/ManagerCreatePage.vue'
import TrailerCreatePage from '@/pages/securityCheck/TrailerCreatePage.vue'
import CompanyCreatePage from '@/pages/securityCheck/CompanyCreatePage.vue'
import ExecutorWizardHub from '@/pages/securityCheck/ExecutorWizardHub.vue'
import ExecutorWizardStep from '@/pages/securityCheck/ExecutorWizardStep.vue'
import TripDetail from '@/pages/trip/TripDetail.vue'
import CustomerDetail from '@/pages/customer/CustomerDetail.vue'
import UsersDetail from '@/pages/users/UsersDetail.vue';

import TestCelery from '@/pages/TestCelery.vue';

import NewAtiList from '@/pages/newAti/MainPage.vue';
import Calculate from '@/pages/trade/Calculate.vue';
import DistributionPage from '@/pages/distribution/DistributionPage.vue';
import PureBiddingPage from '@/pages/pureBidding/PureBiddingPage.vue';
import DowntimesPage from '@/pages/downtimes/DowntimesPage.vue';
import CommercialCalculator from '@/pages/commercialCalculator/CommercialCalculator.vue';
import BaseRatesPage from '@/pages/memory/BaseRatesPage.vue';
import TradingRatesPage from '@/pages/memory/TradingRatesPage.vue';
import DistributionApprovalsPage from '@/pages/admin/DistributionApprovalsPage.vue';
import TmsActionLogPage from '@/pages/admin/TmsActionLogPage.vue';
import DistributorRoutingPage from '@/pages/admin/DistributorRoutingPage.vue';
import CommercialCalculatorSettingsPage from '@/pages/admin/CommercialCalculatorSettingsPage.vue';
import AdvanceBudgetsPage from '@/pages/admin/AdvanceBudgetsPage.vue';
import OrphanCleanupPage from '@/pages/admin/OrphanCleanupPage.vue';
import UserRoutingPage from '@/pages/users/UserRoutingPage.vue';
import GeneralStatisticsPage from '@/pages/statistics/GeneralStatisticsPage.vue';
import DowntimesStatisticsPage from '@/pages/statistics/DowntimesStatisticsPage.vue';
import PersonalStatisticsPage from '@/pages/statistics/PersonalStatisticsPage.vue';
import TransManagerStatisticsPage from '@/pages/statistics/TransManagerStatisticsPage.vue';
import AiAssistantPage from '@/pages/ai/AiAssistantPage.vue';
import AiReportsPage from '@/pages/ai/AiReportsPage.vue';
import AiSettingsPage from '@/pages/ai/AiSettingsPage.vue';
import AiKnowledgePage from '@/pages/ai/AiKnowledgePage.vue';
import Trip360Page from '@/pages/trip360/Trip360Page.vue';
import NotificationsPage from '@/pages/notifications/NotificationsPage.vue';
import LogistSummaryPage from '@/pages/workspace/LogistSummaryPage.vue';
import ClaimsPage from '@/pages/claims/ClaimsPage.vue';
import FinancePage from '@/pages/finance/FinancePage.vue';
import RegistryMonitorPage from '@/pages/registry/RegistryMonitorPage.vue';
import RegistryControlPage from '@/pages/registry/RegistryControlPage.vue';
import RegistrySettingsPage from '@/pages/registry/RegistrySettingsPage.vue';
import RulesPanelPage from '@/pages/admin/RulesPanelPage.vue';
import KnowledgePage from '@/pages/knowledge/KnowledgePage.vue';



const routes = [
  {
    path: '/admin/registry-cycle', name: 'RegistryCycle',
    component: () => import('@/pages/admin/RegistryCyclePage.vue'),
    meta: { requiresAuth: true, registryManagerOnly: true },
  },
  {
    path: '/settings/advance-budgets',
    name: 'AdvanceBudgets',
    component: AdvanceBudgetsPage,
    meta: { requiresAuth: true, permissionAny: ['distribution.admin', 'advance.admin'] },
  },
  {
    path: '/commercial-calculator',
    name: 'CommercialCalculator',
    component: CommercialCalculator,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/commercial-calculator/preview/:draftId',
    name: 'CommercialCalculatorDraftPreview',
    component: CommercialCalculator,
    meta: { requiresAuth: true, permission: 'calculator.settings.write' }
  },
  {
    path: '/commercial-calculator/preview/version/:configVersion',
    name: 'CommercialCalculatorVersionPreview',
    component: CommercialCalculator,
    meta: { requiresAuth: true, permission: 'calculator.settings.read' }
  },
  {
    path: '/calc',
    name: 'Calculate',
    component: Calculate,
    meta: { requiresAuth: true}
  },
  {
    path: '/newAti',
    name: 'NewAtiList',
    component: NewAtiList,
    meta: { requiresAuth: true}
  },
  {
    path: '/test',
    name: 'TestCelery',
    component: TestCelery,
    meta: { requiresAuth: true}
  },
  {
    path: '/topClients',
    name: 'topClients',
    component: TopClients,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'topClients/' }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: CustomerList,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'customers/' }
  },
  {
    path: '/customers/:id',
    name: 'CustomersDetail',
    component: CustomerDetail,
    meta: { requiresAuth: true, nonGuestOnly: true ,model:'customers/' }
  },
  {
    path: '/executors',
    name: 'Executors',
    component: Executors,
    meta: { requiresAuth: true, nonGuestOnly: true ,model:'executors/'}
  },
  {
    path: '/executors/new',
    name: 'ExecutorWizardHub',
    component: ExecutorWizardHub,
    meta: { requiresAuth: true, nonGuestOnly: true ,model:'executors/'}
  },
  {
    path: '/executors/new/:step',
    name: 'ExecutorWizardStep',
    component: ExecutorWizardStep,
    props: true,
    meta: { requiresAuth: true, nonGuestOnly: true ,model:'executors/'}
  },
  {
    path: '/executors/:id/:step',
    name: 'ExecutorDetailStep',
    component: ExecutorDetailStep,
    props: true,
    meta: { requiresAuth: true, nonGuestOnly: true ,model:'executors/'}
  },
  {
    path: '/executors/:id',
    name: 'ExecutorsDetail',
    component: ExecutorsDetail,
    meta: { requiresAuth: true, nonGuestOnly: true ,model:'executors/'}
  },
  {
    // Модуль «Рейсы» (решение Анны 04.11.2026): новый список. Прежний — /trips/classic на время перехода.
    path: '/trips',
    name: 'TripsBoard',
    component: TripsBoardPage,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'trips/' }
  },
  {
    path: '/trips/classic',
    name: 'CargoList',
    component: CargoList,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'trips/' }
  },
  {
    path: '/downtimes',
    name: 'Downtimes',
    component: DowntimesPage,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'trips/' }
  },
  {
    path: '/memory/base-rates',
    name: 'BaseRates',
    component: BaseRatesPage,
    meta: { requiresAuth: true, nonGuestOnly: true, permission: 'memory.base_rates' }
  },
  {
    path: '/memory/trading-rates',
    name: 'TradingRates',
    component: TradingRatesPage,
    meta: { requiresAuth: true, nonGuestOnly: true, permission: 'memory.trading_rates.read' }
  },
  {
    path: '/trips/:id',
    name: 'CargoDetail',
    component: TripDetail,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'trips/' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/user-settings/:id',
    name: 'UserSetting',
    component: UserSetting,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UsersList',
    component: UsersList,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/users/user-routing',
    name: 'UserRouting',
    component: UserRoutingPage,
    meta: { requiresAuth: true, adminOnly: true }
  },   
  {
    path: '/users/:id',
    name: 'UsersDetail',
    component: UsersDetail,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/cars',
    name: 'Car',
    component: CarList,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'cars/' }
  },
  {
    path: '/cars/new',
    name: 'CarCreate',
    component: CarCreatePage,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'cars/' }
  },
  {
    path: '/cars/:id',
    name: 'CarDetail',
    component: CarDetail,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'cars/' }
  },
  {
    path: '/trailers',
    name: 'TrailerList',
    component: TrailerList,
    meta: { requiresAuth: true, nonGuestOnly: true, model: 'cars/' }
  },
  {
    path: '/trailers/new',
    name: 'TrailerCreate',
    component: TrailerCreatePage,
    meta: { requiresAuth: true, nonGuestOnly: true, model: 'cars/' }
  },
  {
    path: '/trailers/:id',
    name: 'TrailerDetail',
    component: TrailerDetail,
    meta: { requiresAuth: true, nonGuestOnly: true, model: 'cars/' }
  },
  {
    path: '/drivers',
    name: 'Driver',
    component: DriverList,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'drivers/'}
  },
  {
    path: '/drivers/new',
    name: 'DriverCreate',
    component: DriverCreatePage,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'drivers/'}
  },
  {
    path: '/drivers/:id',
    name: 'DriverDetail',
    component: DriverDetail,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'drivers/'}
  },
  {
    path: '/managers',
    name: 'ManagerList',
    component: ManagerList,
    meta: { requiresAuth: true, nonGuestOnly: true, model: 'managers/' }
  },
  {
    path: '/managers/new',
    name: 'ManagerCreate',
    component: ManagerCreatePage,
    meta: { requiresAuth: true, nonGuestOnly: true, model: 'managers/' }
  },
  {
    path: '/managers/:id',
    name: 'ManagerDetail',
    component: ManagerDetail,
    meta: { requiresAuth: true, nonGuestOnly: true, model: 'managers/' }
  },
  {
    path: '/companies',
    name: 'Company',
    component: CompanyList,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'companies' }
  },
  {
    path: '/companies/new',
    name: 'CompanyCreate',
    component: CompanyCreatePage,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'companies' }
  },
  {
    path: '/companies/:id',
    name: 'CompanyDetail',
    component: CompanyDetail,
    meta: { requiresAuth: true, nonGuestOnly: true,model:'companies' }
  },
  {
    path: '/admin/security-options',
    name: 'SecurityOptions',
    component: SecurityOptions,
    meta: { requiresAuth: true, adminOnly: true,model:'security' }
  },
  {
    path: '/admin/tms-template',
    name: 'TempaleTmsCandidate',
    component: TempaleTmsCandidate,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/admin/approvals',
    name: 'DistributionApprovals',
    component: DistributionApprovalsPage,
    meta: { requiresAuth: true, permission: 'distribution.approvals' }
  },
  {
    // «Финансы» — только руководителю логистики: доступ проверяет сервер (решение Анны 02.11.2026).
    path: '/finance',
    name: 'Finance',
    component: FinancePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    component: KnowledgePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/rules',
    name: 'RulesPanel',
    component: RulesPanelPage,
    meta: { requiresAuth: true, permission: 'rules.view' }
  },
  {
    path: '/admin/tms-action-log',
    name: 'TmsActionLog',
    component: TmsActionLogPage,
    meta: { requiresAuth: true, permission: 'tms.action_log' }
  },
  {
    path: '/admin/distributor-routing',
    name: 'DistributorRouting',
    component: DistributorRoutingPage,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/admin/orphan-cleanup',
    name: 'OrphanCleanup',
    component: OrphanCleanupPage,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/admin/commercial-calculator-settings',
    name: 'CommercialCalculatorSettings',
    component: CommercialCalculatorSettingsPage,
    meta: { requiresAuth: true, permission: 'calculator.settings.read' }
  },
  {
    path: '/my-ati-route',
    name: 'MyRoutes',
    component: MyRoutes,
    meta: { requiresAuth: true }
  },
  {
    path: '/actual-ati-route',
    name: 'RouteForAti',
    component: RouteForAti,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/ati-route',
    name: 'AtiList',
    component: AtiList,
    meta: { requiresAuth: true, permission: 'ati.route.manage' }
  },
  {
    path: '/ati-route-enrichment',
    name: 'RouteEnrichment',
    component: RouteEnrichment,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/ati-price-check',
    name: 'PriceCheck',
    component: PriceCheck,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/ati-route-cost',
    name: 'RouteCost',
    component: RouteCost,
    meta: { requiresAuth: true, adminOnly: true }
  },
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/summary',
    name: 'LogistSummary',
    component: LogistSummaryPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/claims',
    name: 'Claims',
    component: ClaimsPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/registry',
    name: 'RegistryMonitor',
    component: RegistryMonitorPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/registry/settings',
    name: 'RegistrySettings',
    component: RegistrySettingsPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/registry/:id(\\d+)',
    name: 'RegistryControl',
    component: RegistryControlPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: NotificationsPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/distribution',
    name: 'Distribution',
    component: DistributionPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/distribution/:tripId',
    name: 'DistributionTrip',
    component: DistributionPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },
  {
    path: '/pure-bidding',
    name: 'PureBidding',
    component: PureBiddingPage,
    meta: { requiresAuth: true, nonGuestOnly: true }
  },

  {
    path: '/statistics/general',
    name: 'GeneralStatistics',
    component: GeneralStatisticsPage,
    meta: { requiresAuth: true, permission: 'statistics.general' }
  },
  {
    path: '/statistics/downtimes',
    name: 'DowntimesStatistics',
    component: DowntimesStatisticsPage,
    meta: { requiresAuth: true, permission: 'statistics.general' }
  },
  {
    path: '/statistics/personal',
    name: 'PersonalStatistics',
    component: PersonalStatisticsPage,
    meta: { requiresAuth: true, permission: 'statistics.personal' }
  },
  {
    path: '/statistics/transmanager',
    name: 'TransManagerStatistics',
    component: TransManagerStatisticsPage,
    meta: { requiresAuth: true, permission: 'statistics.transmanager' }
  },

  {
    path: '/ai-assistant',
    name: 'AiAssistant',
    component: AiAssistantPage,
    meta: { requiresAuth: true, permissionAny: ['ai_agent.use', 'statistics.general'] }
  },

  {
    path: '/ai-reports',
    name: 'AiReports',
    component: AiReportsPage,
    meta: { requiresAuth: true, permissionAny: ['ai_agent.use', 'statistics.general'] }
  },

  {
    path: '/ai-settings',
    name: 'AiSettings',
    component: AiSettingsPage,
    meta: { requiresAuth: true, permission: 'ai_agent.settings' }
  },

  {
    path: '/ai-knowledge',
    name: 'AiKnowledge',
    component: AiKnowledgePage,
    meta: { requiresAuth: true, permission: 'ai_agent.use' }
  },

  // Standalone 360-обзор рейса: открывается в отдельном окне/вкладке.
  // bare — без Navbar/Header, весь вьюпорт занимает контент.
  {
    path: '/trip360/:key',
    name: 'Trip360Page',
    component: Trip360Page,
    meta: { requiresAuth: true, permission: 'trip360.view', bare: true }
  },

  //Not found
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound,
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach(async (to,from)=>{
  const store = useStore();
  
  let path = await isAuthRout(to,store)
  if(path) return path

  path = permissionRout(to,store)
  if(path) return path
})

export default router;
